<template>
    <v-container fluid align="center">

      <v-row>
        <v-col align="right">
          <span>v1.0.0</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <img class="userimage" alt="UserImage" src="../assets/user.svg"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
            <span>Bienvenido <b>{{username}}</b></span>
        </v-col>
      </v-row>

      <v-row class="d-flex justify-center" >
        <v-col sm="12" md="6" lg="4">
            <v-select
            v-model="projselected"
            :items="projoptions"
            v-on:change="changeProj"
            label="Proyecto:"
            class="justify-left"
            ></v-select>
        </v-col>
      </v-row>

      <v-row class="d-flex justify-center" >
        <v-col sm="12" md="6" lg="4">
            <v-btn color="success" :disabled="invalid" v-show="invalidAdmin" v-on:click="enterProj({projselected})">Seleccionar Proyecto</v-btn>
        </v-col>
      </v-row>
      
      <v-row class="d-flex justify-center" >
        <v-col sm="12" md="6" lg="4">
            <v-btn color="grey lighten-1" :disabled="invalidAdmin" v-show="invalid" v-on:click="adminProyect({projselected})">Administrar Proyecto</v-btn>
        </v-col>
      </v-row>


    </v-container>
  </template>

<script>
import Vue from 'vue'
import '@/assets/css/welcome.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import  axios  from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faSitemap, faListCheck} from '@fortawesome/free-solid-svg-icons'

library.add(fas);
library.add(faSitemap);
library.add(faListCheck);
//import auth from '@/assets/js/auth.js'
//Vue.use(auth);

export default {
        name: 'welcome',
        created: function () {
            document.title=process.env.VUE_APP_NAME;
            //helper para axios rutas y encabezados default
            require('../assets/js/axioshelper.js')
            let projectsData=[];
            let projectName="";
            let projectOrgName="";
            //Se seleccionan datos de los proyectos disponibles para el usuario
            axios.get("/api/projects/admin")
                .then(async response=>{
                    for (let indexProject in response.data) {
                        projectsData[indexProject]=response.data[indexProject];
                        projectOrgName=await this.getNameOrg(projectsData[indexProject].organization.$oid);
                        if (projectOrgName!==undefined) {
                            projectName=projectOrgName.name+" | "+projectsData[indexProject].name;
                        } else {
                            projectName="No organization Data | "+projectsData[indexProject].name;
                        }
                        this.projoptions.unshift({value:projectsData[indexProject]._id.$oid,text:projectName})
                    }
                    
                }).catch( error=> {
                    console.log("mensaje",error);
                });

                sessionStorage.removeItem('ticketsWaiting');
                this.removeLoadingMessage();
 /*

                if (sessionStorage.idorganization!="null") {
                    axios.get("/api/projects", {
                            params: {
                                organization: sessionStorage.idorganization
                            }
                        })
                        .then(response=>{
                            for (const proj in response.data){
                                if (sessionStorage.idorganization===response.data[proj].organization.$oid && sessionStorage.idorganization!="null") {
                                    this.projoptions.push({value:response.data[proj]._id.$oid,text:response.data[proj].name})
                                } else if (sessionStorage.idorganization==="null" && arg!=null) {
                                    if (arg===response.data[proj].organization.$oid) {
                                        this.projoptions.push({value:response.data[proj]._id.$oid,text:response.data[proj].name})
                                    }
                                } 
                            }
                        })
                        .catch(
                            error=> {
                                console.error("mensaje",error)
                            }
                        )
                }*/
          
        },
        data:() => ({
            username: sessionStorage.username,
            orgselected: sessionStorage.idorganization,
            orgnameselected: null,
            projselected: null,
            projnameselected: null,
            invalid:true,
            invalidAdmin:true,
            orgoptions: [
            { value: null, text: 'Seleccione una organización' },
            ],
            projoptions: [
            { value: null, text: 'Seleccione un projecto' },
            ],

        }),
        methods:{
            getNameOrg: function (idOrg){
                return axios.get("/api/organizations/"+idOrg+"/info")
                            .then(responseOrg=>responseOrg.data)
                            .catch(error=>{
                                let errorName=new Object();
                                errorName.name="Sin Nombre";
                                errorName;
                            });
            },
            loadProj:function(arg) {
                let self =this;
                console.debug("Prueba");
                //Reinicia formulario de selección del proyecto
                if (self.orgselected!=null) {
                    this.projoptions=[
                    { value: null, text: 'Seleccione un projecto' },
                    ];
                    for (const org in self.orgoptions) {
                        if (self.orgselected===self.orgoptions[org].value) {
                            this.orgnameselected=self.orgoptions[org].text;
                        }
                    }
                } else {
                    this.projoptions=[
                    { value: null, text: 'Seleccione una organización primero' },
                    ];       
                }
                this.projselected= null;
                
                //Lista posibles organizaciones
                /* //Se cargaban datos anteriormente según organización seleccionada*/
                // Ahora se cargan al cargar datos de la página.
                axios.get("/api/projects", {
                    params: {
                        organization: arg
                    }
                }).then(response=>{
                    for (const proj in response.data){
                        if (sessionStorage.idorganization===response.data[proj].organization.$oid && sessionStorage.idorganization!="null") {
                            this.projoptions.unshift({value:response.data[proj]._id.$oid,text:response.data[proj].name})
                        } else if (/*sessionStorage.idorganization==="null" && */arg!=null) {
                            if (arg===response.data[proj].organization.$oid) {
                                this.projoptions.unshift({value:response.data[proj]._id.$oid,text:response.data[proj].name})
                            }
                        } 
                    }
                })
                .catch(
                    error=> {
                        console.error("mensaje",error)
                    }
                )
            },
            changeProj: function (arg) {
                let self =this;
                let isAdmin=false;
                axios.get("/api/permissions/mine", {params: { permissions_type: 4, resource: self.projselected }})
                .then(response=>{
                     for (const permission in response.data) {
                        if (response.data[permission]==="automata_manager") {
                            isAdmin=true;
                        }
                     }
                     if (isAdmin) {
                        self.invalidAdmin=!isAdmin;
                     }
                    //Activa el boton para continuar
                    if (arg!=null) {
                        self.invalid=isAdmin;
                    }
                    
                }).catch( error=> {
                    console.log("mensaje",error);
                });


                //Obtiene el nombre del Proyectos Seleccionado
                for (const proj in self.projoptions) {
                        if (self.projselected===self.projoptions[proj].value) {
                            this.projnameselected=self.projoptions[proj].text;
                        }
                    }
                    
            },
            enterProj: function (arg) {
                if (arg!=null) {
                    this.cleanAll();
                    sessionStorage.setItem("selOrganization",this.orgselected);
                    sessionStorage.setItem("selNameOrganization",this.orgnameselected)
                    sessionStorage.setItem("selProject",arg.projselected);
                    sessionStorage.setItem("selNameProject",this.projnameselected);
                    this.$router.push({ path: '/Reviewer'})
                    this.invalid = true;
                }
            },
            cleanAll: function () {
                sessionStorage.removeItem('actual_oid_Img');
                sessionStorage.removeItem('actual_data');
                sessionStorage.removeItem('actual_data_Img');
                sessionStorage.removeItem('actual_predictions');
                sessionStorage.removeItem('actual_elements');
                sessionStorage.removeItem('actual_oid_Res');

                sessionStorage.removeItem('resultOptions');
                sessionStorage.removeItem('resultTypeOid');
                sessionStorage.removeItem('resultType');
                sessionStorage.removeItem('resultTypeId')
            },
            adminProyect: function (arg) {
                if (arg!=null) {
                    sessionStorage.setItem("selOrganization",this.orgselected);
                    sessionStorage.setItem("selNameOrganization",this.orgnameselected)
                    sessionStorage.setItem("selProject",arg.projselected);
                    sessionStorage.setItem("selNameProject",this.projnameselected);
                    this.$router.push({ path: '/Admin'})
                    this.invalid = true;
                }
            },
            removeLoadingMessage () {
                var divs = document.querySelectorAll('.noty_bar.noty_type__info.noty_theme__bootstrap-v4.noty_close_with_click.noty_has_progressbar'); 
                for (var i = 0; i < divs.length; ++i) {
                    divs[i].click();
                };
            },

        }
}
</script>